var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcMantequillaGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,8.73C20,8.73,11.74,14,11.74,20.35a8.38,8.38,0,0,0,1.74,4.93,1.91,1.91,0,0,1,.37,1.24V49.24a2,2,0,0,0,2,2H44.05a2,2,0,0,0,2-2V26.52a2.42,2.42,0,0,1,.36-1.24,8,8,0,0,0,1.82-4.93C48.33,14,40.13,8.73,30,8.73Zm3.55,35c-.29,0-.58-.8-.58-1.74s.29-1.74.58-1.74.58.79.58,1.74S33.88,43.72,33.59,43.72Zm2-14.45a2,2,0,0,1-.87,1.67c0,4.36-.51,7.92-1.09,7.92s-1-3.34-1.09-7.55h-.29c0,2-.5,3.63-1.08,3.63a.61.61,0,0,1-.3-.15c-.21,1-.5,1.6-.79,1.6-.58,0-1.09-2.25-1.09-5.08h-2.4a2,2,0,0,1-2-2V22.16a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcMantequillaGreen);
export default __webpack_public_path__ + "static/media/DC__Mantequilla_green.61584e1f33f01332a956d1ca1e67e96a.svg";
export { ForwardRef as ReactComponent };